module.exports = new __parcel__URL__("timeline-preview-dark.a8fbe72d.svg").toString();